import { render } from "./AlertMe.vue?vue&type=template&id=60398182"
import script from "./AlertMe.vue?vue&type=script&lang=js"
export * from "./AlertMe.vue?vue&type=script&lang=js"

import "./AlertMe.vue?vue&type=style&index=0&id=60398182&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__